<hfc-checkbox-list
  [map]="yesNoMap"
  [readonly]="readonly"
  [(ngModel)]="value"
  (ngModelChange)="onValueChange()"
  [class.hf-invalid]="hfInvalid"
>
</hfc-checkbox-list>
